import { useCallback, useRef } from 'react';

/**
 * Функция задерживает вызов функции на определенное время
 * @param func вызываемая функция.
 * @param delay время задержки по умолчанию 60000мс.
 */
export const useThrottle = <T extends Function>(func: T, delay: number = 60000) => {
  const callbackRef = useRef(func);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  callbackRef.current = func;

  const cancel = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const start = useCallback(() => {
    if (timeoutRef.current) {
      return;
    }

    callbackRef.current();
    timeoutRef.current = setTimeout(() => {
      cancel();
      start();
    }, delay);
  }, [cancel, delay]);

  return { start, cancel };
};
